module.exports = __webpack_public_path__ + "images/android.665362a9.svg";